/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { Form, Formik, Field } from 'formik';
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import FileModal from 'components/FileModal';
import { FitinsurAPI, MessageCenter } from 'utils';
import TextField from 'components/Form/TextField';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Scrollbox, ButtonContent } from './styles';
import { LostCancelButton, TextEditorBox } from 'components/index';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import { useHeaderNbi, useDocument } from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService';

export default function NbiDocStatus(props) {

  const [summary, setSummary] = useState({});
  const history = useHistory();
  const [file, setFile] = useState();
  const [documentStatus, setDocumentStatus] = useState(props.location?.state?.status == 21 ? false : true);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const [initialNbiMessage, setInitialNbiMessage] = useState("");
  const [isBound, setIsBound] = useState(false);

  const [historymsg, setHistorymsg] = useState([]);
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const formik = useRef(null);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useDocumentData,
    loading: useDocumentLoading,
    error: useDocumentError,
    status: useDocumentStatus,
    request: useDocumentRequest,
  } = useDocument();

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useDocumentLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useDocumentLoading]);

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        formik.current?.setFieldValue(
          'additionalNbiClientSubjectivity', 
          data.ret_value.additionalNbiClientSubjectivity
        )
        setInitialNbiMessage(data.ret_value.nbiClientSubjectMessage)
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleFile() {
    useDocumentRequest({idOperation: props.match.params.idOperation, idTemplate: 3}, null).then((a) => {
        if (a.status !== 200) {
            mc.error(`There was an error while fetching your data: ${handleFile.name}\n`);
            history.goBack();
            return;
        } else {
            setFile(a.data);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  function handleBack() {
    history.goBack();
  }

  useEffect(() => {
    let v = handleHistoryMessage();
    if (v) {
      formik.current?.setFieldValue('dealAnalisysInformation', v);
    }
  }, [historymsg])

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };

  function handleAction() {
    history.push(`/broking/market-composition/${props.match.params.idOperation}`, { idProduct: props.location?.state?.idProduct });
  };


  const handleOperationInfo = () => {
    useOperationInfoRequest().then(({data}) => {
        setIsBound(data.isBound || false)
      })
  }

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleFile();
    handleSummary();
    handleOperationInfo();
  }, [])

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <Scrollbox>
        <BrokingSummary data={summary ? summary : ''} />
        <ContentCard title={documentStatus ? "APPROVED NBI" : "REJECTED NBI"} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
          <Formik
            initialValues={{
              nbiClientSubjectMessage: '',
              additionalNbiClientSubjectivity: '',
              dealAnalisysInformation: ''
            }}
            innerRef={formik}
          >
            {(formikProps) => (
              <Form>
                <TextEditorBox
                  label='NBI Message - (External)'
                  name='nbiClientSubjectMessage'
                  initialValue={initialNbiMessage}
                  disabled
                />

                <Field
                  readOnly
                  label={'Additional subjectivities or questions'}
                  name={'additionalNbiClientSubjectivity'}
                  value={formikProps.values.additionalNbiClientSubjectivity}
                  onChange={(e) => formikProps?.setFieldValue('additionalNbiClientSubjectivity', e)}
                  component={TextField}
                />

                <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                <Field
                  readOnly
                  label={'Deal Analysis Information'}
                  name={'dealAnalisysInformation'}
                  value={formikProps.values.dealAnalisysInformation}
                  onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                  component={TextField}
                />
              </Form>
            )}
          </Formik>
          <ButtonContainer>
            <Button forth onClick={() => handleBack()}>&lt; Back</Button>
            <HasPermission permission={!isBound}>
              <RenderButtons idOperation={props.match?.params?.idOperation}>
                <ButtonContent>
                  <div style={{ marginTop: "5px" }}>
                    <LostCancelButton idOperation={props.match?.params?.idOperation} />
                  </div>
                  <HasPermission permission={props.permissions.MARKETING_COMPOSITION && documentStatus}>
                    <Button primary onClick={() => handleAction()} style={{ marginLeft: "10px", marginTop: "5px" }}>
                      COMPOSITION
                    </Button>
                  </HasPermission>
                  <HasPermission permission={props.permissions.MARKET_SELECTION && !documentStatus}>
                    <Button primary onClick={() => handleAction()} style={{ marginLeft: "10px", marginTop: "5px" }}>
                      MARKET SELECTION
                    </Button>
                  </HasPermission>
                </ButtonContent>
              </RenderButtons>
            </HasPermission>
          </ButtonContainer>
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}
